/**
 * notifyMentions — the thin I/O tie between a comment's @mentions and the
 * email outbox. Loads the user directory, builds payloads with the pure
 * `mentionEmailPayloads`, and queues each to the outbox (Brevo in live mode).
 * Returns how many were queued so callers can log honestly. Best-effort:
 * failures never block the comment itself.
 */

import { listAppUsers } from '../db/appUsers';
import { queueEmail } from '../db/outbox';
import { mentionEmailPayloads } from './mentionEmails';

export async function queueMentionEmails(opts: {
  mentions: string[];
  authorName: string;
  context: string;
  url?: string;
}): Promise<number> {
  if (opts.mentions.length === 0) return 0;
  try {
    const users = (await listAppUsers()).map((u) => ({
      displayName: u.displayName,
      email: u.email,
    }));
    const payloads = mentionEmailPayloads({ ...opts, users });
    await Promise.all(payloads.map((p) => queueEmail(p)));
    return payloads.length;
  } catch {
    // Never let notification plumbing break posting a comment.
    return 0;
  }
}
